define('plugin/bonus/view/BonusLayout',['require','lib/view/LayoutView','view/module/MessageView','lib/terms/ClientTermsController'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var MessageView = require('view/module/MessageView');
    var ClientTermsController = require('lib/terms/ClientTermsController');

    /**
     * Invoice layout. Contains regions for payment systems list, invoice info
     *
     * @class BonusLayout
     */
    return LayoutView.extend({

        template: '#bonus_system_layout',

        ui: {
           'confirmBtn' : '#sb_confirm_btn',
        },

        // triggers: {
        //     'click @ui.confirmBtn': 'confirm:bonus:payment'
        // },

        events: {
            'click @ui.confirmBtn': 'confirmBonusPayment'
        },

        regions: {
            'status': '#sb_bonus_status_message',
            'terms': '#sb_terms_and_conditions_alert'
        },

        initialize: function () {
            var _this = this;
            this._clientModel = this.getOption('clientModel');

            if(this._clientModel) {
                this._termsController = ClientTermsController.getInstance({
                    'client': this._clientModel
                });

                console.log(this._clientModel, this._termsController);

                this._termsController.getModel().fetch();
            }
        },

        onRender : function() {
            if(this._termsController) {
                try {
                    this.getRegion("terms")._ensureElement();
                    this.showTermsAndConditions(this._termsController.getPromoAlertView());
                } catch (e) {
                    //console.error(e);
                }
            }
        },

        serializeData: function () {
            var result = LayoutView.prototype.serializeData.apply(this);

            return _.extend({
                is_payment_allowed: this.getOption('paymentAllowed'),
                is_return: this.getOption('isReturn'),
                currency: 'bonus',
            }, result);
        },

        onDomRefresh: function () {
            Backbone.Wreqr.radio.vent.trigger('page', 'shown', {
                'page': 'bonus_buy'
            });
        },

        confirmBonusPayment: function () {
            if(this._termsController) {
                this._clientModel.saveClientTerms(this._termsController.getModel().getAcceptedTermsWithoutPromoFlags());
            }
            this.trigger('confirm:bonus:payment');
        },

        showTermsAndConditions: function (view) {
            //console.log(this.terms.$el.length);

            if(this.terms.$el.length){
                this.showChildView('terms', view);
            }
        },

        showErrorMessage: function (error) {
            this.showChildView('status', new MessageView({
                type: 'danger',
                message: error
            }));

            Backbone.Wreqr.radio.vent.trigger('status_message', 'shown');
        }

    });

});
